export default __webpack_public_path__ + "static/6777-301521ab34b7a7c03aab77bb8d3b22c5.jpg";